import { useAxios, useSubjectMember } from '@healthblocks-io/core'
import { useCallback, useEffect } from 'react'
import { useRecoilState } from 'recoil'

import { unreadMessageCountAtom } from '../state/message.atom'

export function useUnreadMessageCount() {
  const [unreadMessageCount, setUnreadMessageCount] = useRecoilState(unreadMessageCountAtom)

  const axios = useAxios()
  const subjectMember = useSubjectMember()

  const checkUnreadMessageCount = useCallback(async () => {
    try {
      if (!subjectMember?.id) {
        throw new Error('Subject member not found')
      }

      const response = await axios.get<{ count: number }>(`/message/unread/count?subjectId=${subjectMember?.id}`)
      setUnreadMessageCount(response.data.count)
    } catch (error) {
      console.error(error)
    }
  }, [axios, subjectMember?.id, setUnreadMessageCount])

  useEffect(() => {
    checkUnreadMessageCount()
  }, [checkUnreadMessageCount])

  const resetUnreadMessageCount = () => {
    setUnreadMessageCount(0)
  }

  return {
    checkUnreadMessageCount,
    unreadMessageCount,
    resetUnreadMessageCount,
  }
}
